import { EffectCarousel } from "theme";
import { timeline } from "vendor";

const FADE_DURATION = 0.6;

class ImageCarousel extends EffectCarousel {
  constructor() {
    super();
    this.addEventListener("carousel:select", (event) => {
      this._updateArrowVisibility(event.detail.index);
    });
  }

  get loop() {
    return this.hasAttribute("loop");
  }

  connectedCallback() {
    super.connectedCallback();
    this._updateArrowVisibility(this.selectedIndex);
  }

  _updateArrowVisibility(index) {
    const previousButton = this.querySelector(".image-carousel__arrow--prev");
    const nextButton = this.querySelector(".image-carousel__arrow--next");

    previousButton?.toggleAttribute("hidden", index === 0);
    nextButton?.toggleAttribute("hidden", index === this.items.length - 1);
  }

  _shouldReduceMotion() {
    return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  }

  _cancelSlideAnimations(slide) {
    slide.getAnimations().forEach((animation) => animation.cancel());
    slide.style.removeProperty("opacity");
    slide.style.removeProperty("visibility");
    slide.style.removeProperty("z-index");
  }

  _clearTransitionStyles(slide) {
    slide.getAnimations().forEach((animation) => {
      try {
        animation.finish();
      } catch (error) {
        // Animation may already be finished.
      }
      animation.cancel();
    });
    slide.style.removeProperty("opacity");
    slide.style.removeProperty("visibility");
    slide.style.removeProperty("z-index");
  }

  async _transitionTo(fromSlide, toSlide, { animate: shouldAnimate = true } = {}) {
    this._cancelSlideAnimations(fromSlide);
    this._cancelSlideAnimations(toSlide);

    fromSlide.classList.remove("is-selected");
    toSlide.classList.add("is-selected");

    const duration = shouldAnimate && !this._shouldReduceMotion() ? FADE_DURATION : 0;
    const timelineControls = timeline(
      [
        [fromSlide, { opacity: [1, 0], visibility: ["visible", "hidden"], zIndex: 0 }, { zIndex: { easing: "step-end" } }],
        [toSlide, { opacity: [0, 1], visibility: ["hidden", "visible"], zIndex: 1 }, { at: "<", zIndex: { easing: "step-end" } }],
      ],
      { duration },
    );

    try {
      await Promise.race([
        Promise.resolve(timelineControls.finished),
        new Promise((resolve) => setTimeout(resolve, Math.round(duration * 1000) + 80)),
      ]);
    } finally {
      this._clearTransitionStyles(fromSlide);
      this._clearTransitionStyles(toSlide);
    }
  }
}

if (!window.customElements.get("image-carousel")) {
  window.customElements.define("image-carousel", ImageCarousel);
}
